"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCloudService = function IconCloudService(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M36.96 34.46v2h1.32l.267-.002A9.68 9.68 0 0 0 48 27.025l-.012-.274c-.263-4.828-3.97-8.667-8.655-9.166l-.077-.008-.008-.28C38.964 10.473 33.702 5 27 5l-.34.01a13.55 13.55 0 0 0-10.605 5.901l-.027.039-.164-.134A8.45 8.45 0 0 0 11.051 9C7.211 9 4.55 12.046 4.55 16l.007.406q.007.202.022.406l.018.191-.05.037A11.63 11.63 0 0 0 0 25.975C0 31.868 4.973 36.46 11 36.46v-2l-.265-.003C5.9 34.327 2 30.642 2 26a9.62 9.62 0 0 1 4.221-7.702l.523-.355-.096-.625-.043-.327a9 9 0 0 1-.055-.988C6.55 13.095 8.38 11 11 11a6.43 6.43 0 0 1 4.477 2.198l.944 1.082.687-1.262.16-.284A11.54 11.54 0 0 1 27.02 7c5.745 0 10.26 4.88 10.241 10.917v1.617l1.004-.004.245.003A7.71 7.71 0 0 1 46 27.027c-.106 4.127-3.535 7.454-7.715 7.433l-.005.801v-.801zM23.99 20.95c-6.136 0-11.11 4.974-11.11 11.11s4.974 11.11 11.11 11.11S35.1 38.196 35.1 32.06s-4.974-11.11-11.11-11.11m0 2a9.11 9.11 0 1 1 0 18.22 9.11 9.11 0 0 1 0-18.22M26 33.16h-1.79L27 38l2.79-4.84H28V28h-2zm-4-2.32V36h-2v-5.16h-1.79L21 26l2.79 4.84z",
    clipRule: "evenodd"
  })));
};

export { IconCloudService, IconCloudService as default };
